import { AxiosStatic } from 'axios';
import ABApiRoutes from '@/api/ABApiRoutes';
import { IApiCalendarDoorContent, IApiRequestObject } from '@/common/interfaces/api.interface';
import ApiHelper from '@/helpers/ApiHelper';
import CookieHelper from '@/helpers/CookieHelper';
import config from '../../config';

export default class ABApiService {
  private axios: AxiosStatic;

  constructor(axios: AxiosStatic) {
    this.axios = axios;
    this.axios.defaults.withCredentials = true;
  }

  private async fetch<T>(apiRoute: ABApiRoutes, object: IApiRequestObject = {}): Promise<T> {
    let data;
    try {
      const requestConfig = ApiHelper.getRequestConfig(apiRoute, object);
      requestConfig.baseURL = config.announcementbar.url;
      ({ data } = await this.axios.request(requestConfig));
    } catch (err) {
      ApiHelper.handleKnownApiError(err, apiRoute);
    }
    return data;
  }

  public async getDoorById(id: number): Promise<IApiCalendarDoorContent> {
    return this.fetch<IApiCalendarDoorContent>(ABApiRoutes.getDoorById, {
      data: { language: CookieHelper.getLanguage() },
      params: { id },
    });
  }
}
